import { UIAjaxWrapper } from '../../../shared/scripts/network/UIAjaxWrapper.ts';
import { UIPopupManager } from '../../../shared/scripts/ui_popup/UIPopupManager.ts';
import { UIMSceneEnum } from '../../../../shared/enums/UIMSceneEnums.ts';
import { UIMFullscreenPageController } from './UIMFullscreenPageController.ts';
import { UIReplayController } from '../../../shared/scripts/ui_replay/UIReplayController.ts';
import { UIGameSpriteHandler } from '../../../shared/scripts/UIGameSpriteHandler.ts';
import { socket } from '../../../shared/scripts/EntryShared.ts';
import { getReplayDataUrl } from '../../../shared/scripts/ui_replay/ReplayUrlUtilities.ts';
import { ClientUserState } from '../../../shared/scripts/ClientUserState.ts';
import { showPageNavigationWarning } from '../ui_popup/showPageNavigationWarning.ts';
import { uiManager } from '../EntryMobile.ts';
import { navigateToPage } from '../../../shared/scripts/ui_utils/ClientUtils.ts';
import { UIUrlParameterNames } from '../../../shared/scripts/ui_html/UIUrlController.ts';
import { UIEntryUrlParameterController } from '../../../shared/scripts/UIEntryUrlParameterController.ts';
import { UIViewProfilePopup } from '../../../shared/scripts/profile/UIViewProfilePopup.ts';
import { matchMobileRoute } from './MobileRouteResolver.ts';
import { UIUtilsEjsVariables } from '../../../shared/scripts/UIUtilsEjsVariables.ts';
export class UIMSingletonPageController extends UIMFullscreenPageController {
    navigateToHref(href) {
        var _this_mainpageController_headerController_notificationPanelController, _this_mainpageController, _this_mainpageController1;
        const pageUrl = UIMSingletonPageController.getSingletonPageUrl(href);
        if (!pageUrl) return false;
        if (pageUrl.startsWith('#')) {
            const hash = href.split('#')[1];
            if (hash) {
                const elementToScrollTo = document.getElementById(hash);
                elementToScrollTo === null || elementToScrollTo === void 0 ? void 0 : elementToScrollTo.scrollIntoView({
                    behavior: 'smooth'
                });
            }
            return true;
        }
        if (pageUrl.includes('/static')) return true;
        if (pageUrl.includes('/dist')) return true;
        UIPopupManager.closeAllPopups();
        (_this_mainpageController = this.mainpageController) === null || _this_mainpageController === void 0 ? void 0 : (_this_mainpageController_headerController_notificationPanelController = _this_mainpageController.headerController.notificationPanelController) === null || _this_mainpageController_headerController_notificationPanelController === void 0 ? void 0 : _this_mainpageController_headerController_notificationPanelController.hideNotificationPanel();
        (_this_mainpageController1 = this.mainpageController) === null || _this_mainpageController1 === void 0 ? void 0 : _this_mainpageController1.sceneController.closeOverlays();
        if (this.handleUrlRedirect(href)) return true;
        this.openUrl(pageUrl);
        return true;
    }
    handleUrlRedirect(href) {
        const pathname = UIMSingletonPageController.getSingletonPageUrl(href);
        var _href_split_;
        const hash = (_href_split_ = href.split('#')[1]) !== null && _href_split_ !== void 0 ? _href_split_ : '';
        if (!pathname) return false;
        if (hash == `${UIUrlParameterNames.MainPage}=${UIEntryUrlParameterController.DEFAULT_PARAMETER_VALUE}`) {
            this.redirectToScene(UIMSceneEnum.Homepage);
            return true;
        }
        if (hash.startsWith(`${UIUrlParameterNames.SelectMode}=`)) {
            const requestedMatchType = hash.split('=')[1];
            this.redirectToScene(UIMSceneEnum.Homepage);
            void uiManager.goToMainPageAndSelectMatchType(requestedMatchType);
            return true;
        }
        if (hash == `${UIUrlParameterNames.Spectate}=${UIEntryUrlParameterController.DEFAULT_PARAMETER_VALUE}`) {
            this.redirectToScene(UIMSceneEnum.Lobby);
            this.mainpageController.bodyController.lobbyController.tableController.headerController.openSpectateTab();
            return true;
        }
        const matchedRoute = matchMobileRoute(pathname);
        if (matchedRoute == undefined) return false;
        switch(matchedRoute){
            case '/store':
            case '/checkout':
                var _this_mainpageController_bodyController_storeController_sidebarController, _this_mainpageController_bodyController_storeController, _this_mainpageController_bodyController, _this_mainpageController;
                this.redirectToScene(UIMSceneEnum.Store);
                if (hash) (_this_mainpageController = this.mainpageController) === null || _this_mainpageController === void 0 ? void 0 : (_this_mainpageController_bodyController = _this_mainpageController.bodyController) === null || _this_mainpageController_bodyController === void 0 ? void 0 : (_this_mainpageController_bodyController_storeController = _this_mainpageController_bodyController.storeController) === null || _this_mainpageController_bodyController_storeController === void 0 ? void 0 : (_this_mainpageController_bodyController_storeController_sidebarController = _this_mainpageController_bodyController_storeController.sidebarController) === null || _this_mainpageController_bodyController_storeController_sidebarController === void 0 ? void 0 : _this_mainpageController_bodyController_storeController_sidebarController.openDefaultStorePage(`#${hash}`);
                return true;
            case '/leaderboards':
                this.redirectToScene(UIMSceneEnum.Leaderboard);
                return true;
            case '/profile':
                {
                    const showedProfilePopup = this.shouldOpenProfilePopup(href);
                    if (!showedProfilePopup) {
                        showPageNavigationWarning(()=>{
                            var _uiManager_mainpageController_sceneController, _uiManager_mainpageController;
                            if ((uiManager === null || uiManager === void 0 ? void 0 : (_uiManager_mainpageController = uiManager.mainpageController) === null || _uiManager_mainpageController === void 0 ? void 0 : (_uiManager_mainpageController_sceneController = _uiManager_mainpageController.sceneController) === null || _uiManager_mainpageController_sceneController === void 0 ? void 0 : _uiManager_mainpageController_sceneController.scene) == UIMSceneEnum.Game) {
                                var _ClientUserState_userState_username, _ClientUserState_userState;
                                return navigateToPage(`/profile/${(_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : (_ClientUserState_userState_username = _ClientUserState_userState.username) === null || _ClientUserState_userState_username === void 0 ? void 0 : _ClientUserState_userState_username.toLowerCase()}`);
                            } else {
                                this.closePage();
                                uiManager.mainpageController.profileOverlayController.show();
                            }
                        });
                    }
                    return true;
                }
            case '/replay':
                showPageNavigationWarning(()=>{
                    var _uiManager_mainpageController_sceneController, _uiManager_mainpageController;
                    if ((uiManager === null || uiManager === void 0 ? void 0 : (_uiManager_mainpageController = uiManager.mainpageController) === null || _uiManager_mainpageController === void 0 ? void 0 : (_uiManager_mainpageController_sceneController = _uiManager_mainpageController.sceneController) === null || _uiManager_mainpageController_sceneController === void 0 ? void 0 : _uiManager_mainpageController_sceneController.scene) == UIMSceneEnum.Game) {
                        return navigateToPage(href);
                    }
                    const replayDataUrl = getReplayDataUrl(href);
                    this.loadReplay(replayDataUrl);
                });
                return true;
            case '/catan-rules':
                // eslint-disable-next-line no-restricted-syntax
                window.location.href = '/catan-rules';
                return true;
            case '/timer':
                // eslint-disable-next-line no-restricted-syntax
                window.location.href = '/timer';
                return true;
            case '/faq':
                if (UIUtilsEjsVariables.isUserOnDiscordMobile) {
                    navigateToPage(hash ? `/faq#${hash}` : '/faq', true);
                    return true;
                }
                this.openUrl(matchedRoute);
                return true;
            default:
                this.openUrl(matchedRoute);
                return true;
        }
    }
    // eslint-disable-next-line class-methods-use-this
    shouldOpenProfilePopup(href) {
        var _ClientUserState_userState_username, _ClientUserState_userState;
        const profileUsername = UIMSingletonPageController.getProfileUsername(href);
        if (!profileUsername) return false;
        if (profileUsername.toLowerCase() == ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : (_ClientUserState_userState_username = _ClientUserState_userState.username) === null || _ClientUserState_userState_username === void 0 ? void 0 : _ClientUserState_userState_username.toLowerCase())) return false;
        UIViewProfilePopup.init(profileUsername);
        return true;
    }
    static getProfileUsername(href) {
        if (!href.includes('/profile')) return;
        const fullUrl = href.startsWith('http') ? href : window.location.origin + href;
        const url = new URL(fullUrl);
        const pathnameParts = url.pathname.split('/');
        const username = pathnameParts[pathnameParts.length - 1];
        if (!username) return;
        return username;
    }
    setLinkListeners() {
        if (UIUtilsEjsVariables.isUserOnDiscordMobile) return;
        UIMSingletonPageController.routesListener = (event)=>{
            const clickedElement = event.target;
            if (clickedElement == undefined) return;
            const href = UIMSingletonPageController.getElementHref(clickedElement);
            if (!href) return;
            const pageUrl = UIMSingletonPageController.getSingletonPageUrl(href);
            if (!pageUrl) return;
            event.preventDefault();
            this.navigateToHref(href);
        };
        document.addEventListener('click', UIMSingletonPageController.routesListener);
    }
    // eslint-disable-next-line class-methods-use-this
    removeLinkListener() {
        document.removeEventListener('click', UIMSingletonPageController.routesListener);
    }
    loadReplay(replayUrl) {
        void UIGameSpriteHandler.continueAfterAssetsLoad(async ()=>{
            const replayDataUrl = replayUrl;
            const replayDataResponse = await UIAjaxWrapper.getRequestHandler(replayDataUrl, undefined);
            const replayInitiationData = replayDataResponse === null || replayDataResponse === void 0 ? void 0 : replayDataResponse.json.data;
            if (replayInitiationData === undefined) throw new Error('Missing replayData');
            this.redirectToScene(UIMSceneEnum.Game);
            const isLiveGame = false;
            new UIReplayController(replayInitiationData, socket.actionController, isLiveGame);
        });
    }
    static getElementHref(clickedElement) {
        var _clickedElement_parentElement;
        const element = clickedElement.tagName;
        const isATag = element == 'A';
        if (isATag) return clickedElement.getAttribute('href');
        return (_clickedElement_parentElement = clickedElement.parentElement) === null || _clickedElement_parentElement === void 0 ? void 0 : _clickedElement_parentElement.getAttribute('href');
    }
    static getSingletonPageUrl(href) {
        const urlContainsSiteDomain = href.startsWith(window.location.origin);
        if (urlContainsSiteDomain) return new URL(href).pathname;
        const isHash = href.startsWith('#');
        if (isHash) return href;
        const urlIsRelative = href.startsWith('/');
        if (!urlIsRelative) return;
        if (href.includes('catan-rules')) return;
        if (href.includes('/auth/')) return;
        return href;
    }
    redirectToScene(scene) {
        this.mainpageController.sceneController.loadScene(scene);
        this.closePage();
        return;
    }
    // eslint-disable-next-line class-methods-use-this
    updatePageOnHashChange() {
        window.onhashchange = (hashChangeEvent)=>{
            const oldUrl = new URL(hashChangeEvent.oldURL);
            const newUrl = new URL(hashChangeEvent.newURL);
            const isTheSameHash = oldUrl.hash.toLocaleLowerCase() == newUrl.hash.toLocaleLowerCase();
            if (isTheSameHash) return;
            const hashesNotEmpty = oldUrl.hash != '' && newUrl.hash != '';
            if (!hashesNotEmpty) return;
            location.reload();
        };
    }
    constructor(mainpageController){
        super();
        this.mainpageController = mainpageController;
        this.setLinkListeners();
        this.updatePageOnHashChange();
    }
}
